<div class="text-center mt-5">
    <h1 class="text-danger">403 - Acceso Denegado</h1>
    <p>No tienes permisos para acceder a esta página.</p>
    <a routerLink="/" class="btn btn-primary mt-3">Volver al inicio</a>
  </div>
